import { StyleSheet } from 'react-native';
import { COLORS } from './colors';

export const styles = StyleSheet.create({
    layout: {
      backgroundColor: COLORS.PRIMARY[80],
      // grow to fit content (was flex:1, which capped it at viewport height and let
      // taller pages spill onto the white page background below the teal frame)
      flexGrow: 1,
      minHeight: '100%',
      paddingVertical: 40,
      paddingHorizontal: '5%',
      flexDirection: 'column',
      display: 'flex',
      borderRadius: 20,
      shadowColor: '#171717',
      shadowRadius: 3,
      shadowOpacity: 0.2,
      shadowOffset: { width: -1, height: 4 },
      gap: 10
    }
  });